import {
  AutoComplete,
  FormInput,
  IInputFile,
  ISelectType,
  SwitchInput,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useState } from "react";
import BannersApps from "./BannersApps";
import BannersLocals from "./BannersLocals/BannersLocals";
import BannerFile from "./BannerFile/BannerFile";
import BannerMobileFile from "./BannerMobileFile/BannerMobileFile";
import BannersPreview from "./BannersPreview/BannersPreview";
import { useTranslation } from "react-i18next";
import MainApiService from "../../../../../services/mainApi.service";

const translationPath = "page.register.banners.";

const LANGUAGE_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Language/";
const languageService = new MainApiService<ISelectType>(LANGUAGE_ROUTE);

interface IBannerFieldsProps {
  deleteFilesList: string[];
}

export const BannerFields = memo(({ deleteFilesList }: IBannerFieldsProps) => {
  const { t } = useTranslation();
  const onDeleFileHandler = (file: IInputFile) => {
    const selectedFile = file;
    if (selectedFile.id.length !== 0) {
      deleteFilesList.push(selectedFile.id);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} textAlign={"end"}>
        <SwitchInput
          name="enable"
          label={t(translationPath + "enable") || "Enable"}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormInput
          size="small"
          name="name"
          fullWidth
          label={t(translationPath + "name") || "Name"}
          autoFocus
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormInput
          size="small"
          name="title"
          fullWidth
          label={t(translationPath + "title") || "Title"}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormInput
          size="small"
          name="alternativeText"
          fullWidth
          label={t(translationPath + "alternative_text") || "Alternative text"}
        />
      </Grid>

      <Grid item xs={12} sm={2}>
        <FormInput
          size="small"
          name="displayOrder"
          fullWidth
          label={t(translationPath + "display_order") || "Display order"}
          type="number"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <AutoComplete
          getOptionLabel={(option) => {
            return option.name;
          }}
          size="small"
          label={t(translationPath + "language")}
          name="language"
          request={languageService.list}
        />
      </Grid>

      <BannersApps />

      <BannersLocals />

      <Grid item xs={12}>
        <FormInput
          size="small"
          name="targetingLink"
          fullWidth
          label={t(translationPath + "targetingLink") || "targetingLink order"}
        />
      </Grid>

      <BannerFile onFileSelected={onDeleFileHandler} />
      <BannerMobileFile onFileSelected={onDeleFileHandler} />

      <BannersPreview />
    </Grid>
  );
});
